document.addEventListener('DOMContentLoaded', function () {
    const mapDataElement = document.getElementById('locations-map-data');

    if (mapDataElement) {
        const locations = JSON.parse(mapDataElement.getAttribute('data-locations'));
        const map = L.map('locations-map', {
            gestureHandling: true,
            doubleClickZoom: false,
        }).setView([52.05, 16], 9);

        const customMarker = {
            iconUrl: `${document.location.origin}/wp-content/themes/gwozdz/dist/images/marker.svg`,
            iconSize: [48, 48],
            active: false,
        };

        const customMarkerActive = {
            iconUrl: `${document.location.origin}/wp-content/themes/gwozdz/dist/images/marker-active.svg`,
            iconSize: [48, 48],
            active: true,
        };

        const specialMarker = {
            iconUrl: `${document.location.origin}/wp-content/themes/gwozdz/dist/images/marker-office.svg`,
            iconSize: [48, 48],
            active: false,
        };

        if (mapDataElement && locations && map) {
            L.tileLayer('https://tile.jawg.io/jawg-light/{z}/{x}/{y}{r}.png?access-token=sJmUacRXGWmZHhBNr5XzzpD5voqo2eX2QWafeawpSa1CLywcVYUMarvIBlFIXXhW', {
                minZoom: 6,
                maxZoom: 20,
                subdomains: 'abcd',
                className: 'mapLayer',
                attribution:
                    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; ' +
                    '<a href="https://carto.com/attributions">CARTO</a>',
            }).addTo(map);

            if (locations && locations.length > 0) {
                console.log(locations);
                const markers = L.markerClusterGroup({
                    showCoverageOnHover: false,
                    removeOutsideVisibleBounds: false,
                });

                const myMarker = L.icon(customMarker);
                const myActiveMarker = L.icon(customMarkerActive);
                const mySpecialMarker = L.icon(specialMarker);

                const iconOptions = {
                    title: 'Piekarnia Gwóźdź',
                    draggable: false,
                    icon: myMarker,
                };

                function getPopupOffset() {
                    const width = window.innerWidth;
                    if (width < 768) {
                        // Mobile
                        return L.point(0, 0);
                    } else if (width < 1024) {
                        // Tablet
                        return L.point(-150, 150);
                    } else {
                        // Desktop
                        return L.point(-300, 230);
                    }
                }

                locations.forEach(function (location,index) {
                    let markerIcon = myMarker;
                    if (location.is_office) {
                        markerIcon = mySpecialMarker;
                    }

                    const marker = L.marker([location.x, location.y], {
                        ...iconOptions,
                        icon: markerIcon,
                    })
                        .on('click', () => {
                            if (marker.options.icon.options.active) {
                                marker.setIcon(myMarker);
                            } else {
                                marker.setIcon(myActiveMarker);
                            }
                        })
                        .bindPopup(
                            `<b class="city">${location.city}</b>
                        <span class="street">${location.street}</span>
                         <span class="phone">tel. ${location.phone}</span>
                        <span class="hours-span">Godziny otwarcia</span>
                        <span class="hours-item"><span>Pn - Pt:</span> <span>${location.hours_week}</span></span>
                        <span class="hours-item"><span>Sobota:</span> <span>${location.hours_saturday}</span></span>
                        <span class="hours-item"><span>Niedziela:</span> <span>${location.hours_sunday}</span></span>`,
                            { offset: getPopupOffset() },
                        );
                    markers.addLayer(marker);
                    marker.getPopup().on('remove', function () {
                        marker.setIcon(myMarker);
                    });
                });

                map.addLayer(markers);
                const popup = L.popup().openOn(map);
            }
        }
    }
});
